
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30877',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30877",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55443",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8417",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11870",
  "I18n": "static-7.1688",
  "quartz": "static-1.7549",
  "quartz-config": "static-1.1327",
  "quartz-core": "static-1.6768",
  "react-dlb": "static-1.92",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.83",
  "reselect": "static-3.15",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1003",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55430",
  "feedback-utils": "static-1.55434",
  "forms-embed-utils-lib": "static-1.4847",
  "forms-utils-lib": "static-1.13194",
  "foundations-assets": "static-1.5269",
  "foundations-components": "static-1.8606",
  "foundations-theming": "static-1.4859",
  "hub-http": "static-1.6592",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12177",
  "icons": "static-2.696",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4173",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17108",
  "react-select-plus": "static-1.116",
  "react-utils": "static-2.5604",
  "react-virtualized": "static-2.110",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.511",
  "tinymce-plugins": "static-1.58353",
  "transmute": "static-2.97",
  "ui-images": "static-2.1266",
  "UIComponents": "static-3.8816",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3826",
  "quartz-webpack": "static-1.3773",
  "foundations-theming-specialty": "static-1.2575",
  "property-description-translator": "static-1.4205",
  "HeadJS": "static-2.809",
  "framer-motion": "static-1.82",
  "hs-test-utils-bend-plugin": "static-1.3528",
  "msw": "static-1.39",
  "msw-config": "static-1.14",
  "testing-library": "static-1.162",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4692",
  "jasmine-runner": "static-1.6830",
  "opentelemetry-fe-types": "static-1.166",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.895",
  "hubspotter-http": "static-1.4908",
  "mobile-manifest-mixins": "static-1.590",
  "module-federation": "static-1.36",
  "opentelemetry-fe": "static-1.541",
  "quartz-auth": "static-1.1224",
  "quartz-head": "static-1.1214",
  "quartz-i18n": "static-1.1224",
  "quartz-routing": "static-1.979",
  "quartz-test": "static-1.1224",
  "quartz-tracking": "static-1.928",
  "trellis-components": "static-1.2865",
  "ui-fonts": "static-1.1132",
  "usage-tracker-container": "static-1.7684",
  "usage-tracker-core": "static-1.7544",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.271",
  "conversations-skeleton-state": "static-1.7602",
  "reference-resolvers": "static-1.8564",
  "sanitize-text": "static-1.8538",
  "PatternValidationJS": "static-1.3271",
  "ReduxMessenger": "static-2.10753",
  "outpost": "static-1.4520",
  "rpc-client-utils": "static-1.5047",
  "sanitize": "static-1.4853",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4875",
  "floating-ui": "static-1.66",
  "hs-story-utils": "static-1.9805",
  "react-aria": "static-1.75",
  "react-create-root-preference": "static-1.86",
  "tanstack-table": "static-1.64",
  "trellis-assets": "static-1.2846",
  "bend-plugin-foundations-theming": "static-1.3342",
  "foundations-theming-base": "static-1.3844",
  "stylex": "static-1.45",
  "hs-locale-management": "static-1.345",
  "csstype": "static-1.50",
  "web-vitals": "static-1.18",
  "ai-components-ui-library": "static-1.9863",
  "atom": "static-1.5462",
  "codemirror": "static-5.105",
  "content-assistance-lib": "static-1.8296",
  "ContentUtils": "static-1.69279",
  "data-token-picker": "static-1.16991",
  "file-manager-components": "static-1.24655",
  "FileManagerCore": "static-1.40154",
  "FileManagerLib": "static-1.40295",
  "frontend-preferences-client": "static-1.8302",
  "hub-http-contrib": "static-1.3408",
  "interframe": "static-3.5124",
  "layout-dnd-components": "static-1.13077",
  "layout-dnd-utils": "static-1.12052",
  "property-translator": "static-1.5762",
  "react-codemirror": "static-1.11023",
  "react-colorpicker": "static-2.10595",
  "reference-resolvers-lite": "static-1.8484",
  "rich-text-lib": "static-1.20417",
  "tinymce-data": "static-1.41324",
  "tinymce-themes": "static-1.57209",
  "ui-addon-emoji-picker": "static-1.10252",
  "ui-addon-sales-email": "static-1.5584",
  "ui-brand-identity-lib": "static-1.16716",
  "bender-build-tools": "static-1.3452",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.86",
  "hub-http-shared-msw-handlers": "static-1.10743",
  "hubspotter-http-shared-msw-handlers": "static-1.10741",
  "usage-tracker-session-replay": "static-1.5380",
  "base-ui": "static-1.25",
  "react-day-picker": "static-1.13",
  "trellis-theming": "static-1.1358",
  "tanstack-virtual": "static-1.41",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.457",
  "chirp-fetch": "static-1.2280",
  "stylex-utils": "static-1.155",
  "chatspot-core": "static-1.23343",
  "copilot-toolkit": "static-1.11977",
  "customer-data-objects-ui-components": "static-1.13412",
  "data-fetching-client": "static-1.10029",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5141",
  "ui-addon-video-player": "static-1.9057",
  "ui-coaching-tips": "static-1.29441",
  "usage-tracker": "static-1.7694",
  "cms-field-types": "static-1.5193",
  "content-icons-ui": "static-1.2412",
  "integrations-lib": "static-1.17219",
  "customer-data-objects": "static-1.8072",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.1927",
  "apollo-link-hub-http": "static-2.5013",
  "apollo-stack-hubspot": "static-3.97",
  "graphql": "static-1.92",
  "immer": "static-1.104",
  "immerable": "static-1.4526",
  "poll-commands": "static-1.3853",
  "ui-addon-iframeable": "static-1.9460",
  "video-components-external": "static-1.12275",
  "video-data-lib": "static-1.35933",
  "breeze-artifacts-sdk": "static-1.580",
  "audio-components": "static-1.6445",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29916",
  "FileManagerImages": "static-1.37806",
  "foundations-components-legacy": "static-1.1631",
  "html-to-image": "static-1.64",
  "redux-toolkit": "static-1.81",
  "salesImages": "static-1.643",
  "ui-universal-auth": "static-1.9548",
  "urlinator": "static-1.4899",
  "video-components": "static-1.14277",
  "video-embed": "static-1.36767",
  "ts-schema": "static-1.4343",
  "ContentData": "static-1.69354",
  "layout-data-lib": "static-1.10377",
  "react-dnd-compat": "static-1.4996",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1927",
  "external-options-client-types": "static-1.4390",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7277",
  "hs-promise-utils": "static-1.5970",
  "inbound-db-properties-service-client": "static-1.4092",
  "NamespacedHubStyle": "static-2.9308",
  "growth-onboarding-confetti": "static-1.3446",
  "SharedI18nStrings": "static-1.186",
  "ui-addon-i18n": "static-1.11531",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5819",
  "magpie-types": "static-1.5279",
  "simple-logging-lib": "static-1.3434",
  "avatar-components": "static-1.2864",
  "customer-data-ui-utilities": "static-1.10213",
  "growth-onboarding-feedback-components": "static-1.6966",
  "flux-actions": "static-1.377",
  "hubspot-apollo-client": "static-1.5256",
  "integrations-error-boundary-lib": "static-1.14634",
  "integrations-tracking-lib": "static-1.5993",
  "laboratory-lib": "static-3.7534",
  "native-integrations-shared-strings": "static-1.8147",
  "redux-observable": "static-1.78",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10653",
  "unified-auth": "static-1.1062",
  "breeze-engine-chat-components": "static-1.905",
  "breeze-engine-core": "static-1.1205",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "pulse": "static-1.1013",
  "navigation-messaging": "static-1.8292",
  "content-media-composition-data-lib": "static-1.13401",
  "content-media-compositions": "static-2.17408",
  "idb-keyval": "static-1.54",
  "media-bridge-lib": "static-1.19507",
  "nudge-client-utils": "static-1.3256",
  "unified-auth-core-lib": "static-1.1344",
  "social-insights-client-types": "static-1.22768",
  "advanced-menus-core": "static-1.15675",
  "advanced-menus-lib": "static-1.12508",
  "ExportDialog": "static-6.10759",
  "ui-memberships-settings-lib": "static-1.34974",
  "conditional-properties-service-client": "static-1.4065",
  "crm-pipelines-api-client-types": "static-1.4396",
  "fdsr-migration-layer": "static-1.396",
  "framework-builder-read-service-client": "static-1.4270",
  "framework-data-schema-quick-fetch": "static-1.7182",
  "inbound-db-meta-service-client": "static-1.3721",
  "multi-currency-client-types": "static-1.3959",
  "persist-promise": "static-1.4084",
  "foundations-components-test-utils": "static-1.6089",
  "reactive-lib": "static-1.1103",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.715",
  "universal-page-editor-lib": "static-1.3392",
  "adobe-sign-auth-lib": "static-1.604",
  "ads-unified-auth-lib": "static-1.1631",
  "custom-vendor-connection-lib": "static-1.112",
  "google-sheets-integration-lib": "static-1.1167",
  "microsoft-drive-auth-lib": "static-1.315",
  "surveymonkey-integration-lib": "static-1.660",
  "slack-ui-library": "static-1.10779",
  "bend-plugin-pulse": "static-1.516",
  "event-emitter": "static-1.1340",
  "fast-json-patch": "static-1.73",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3013",
  "nudge-renderer-utils": "static-1.3332",
  "onboarding-tours": "static-1.17247",
  "whisper-core-api": "static-1.7469",
  "fsm": "static-1.4135",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15674",
  "simple-menus-lib": "static-1.17191",
  "settings-ui-lib": "static-1.12906",
  "crm-record-cards-service-types": "static-1.3818",
  "location-customization-utils-lib": "static-1.10246",
  "getting-started-shared-tasks": "static-1.19387",
  "growth-data-modal": "static-1.5997",
  "growth-onboarding-next-action-utils": "static-1.2824",
  "navigation-components": "static-1.18965",
  "onboarding-tours-client": "static-1.5462",
  "onboarding-tours-utils": "static-1.1314",
  "ui-shepherd-tracker": "static-1.8034",
  "user-context": "static-1.5473",
  "react-flip-move": "static-1.81",
  "onboarding-data-sync-lib": "static-1.2662",
  "growth-onboarding-next-action-components": "static-1.2852",
  "user-context-client": "static-1.4890",
  "nest": "static-1.616",
  "getting-started-shared-tasks-store": "static-1.18505",
  "InboxConnectUtils": "static-4.15686",
  "meetings-connect-utils-lib": "static-1.7993",
  "onboarding-scopes": "static-1.6834"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30877",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55443",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8417",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11870",
  "I18n": "/I18n/static-7.1688",
  "quartz": "/quartz/static-1.7549",
  "quartz-config": "/quartz-config/static-1.1327",
  "quartz-core": "/quartz-core/static-1.6768",
  "react-dlb": "/react-dlb/static-1.92",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.83",
  "reselect": "/reselect/static-3.15",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1003",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55430",
  "feedback-utils": "/feedback-utils/static-1.55434",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4847",
  "forms-utils-lib": "/forms-utils-lib/static-1.13194",
  "foundations-assets": "/foundations-assets/static-1.5269",
  "foundations-components": "/foundations-components/static-1.8606",
  "foundations-theming": "/foundations-theming/static-1.4859",
  "hub-http": "/hub-http/static-1.6592",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12177",
  "icons": "/icons/static-2.696",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4173",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17108",
  "react-select-plus": "/react-select-plus/static-1.116",
  "react-utils": "/react-utils/static-2.5604",
  "react-virtualized": "/react-virtualized/static-2.110",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.511",
  "tinymce-plugins": "/tinymce-plugins/static-1.58353",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1266",
  "UIComponents": "/UIComponents/static-3.8816",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3826",
  "quartz-webpack": "/quartz-webpack/static-1.3773",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2575",
  "property-description-translator": "/property-description-translator/static-1.4205",
  "HeadJS": "/HeadJS/static-2.809",
  "framer-motion": "/framer-motion/static-1.82",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3528",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.14",
  "testing-library": "/testing-library/static-1.162",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4692",
  "jasmine-runner": "/jasmine-runner/static-1.6830",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.166",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.895",
  "hubspotter-http": "/hubspotter-http/static-1.4908",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.590",
  "module-federation": "/module-federation/static-1.36",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.541",
  "quartz-auth": "/quartz-auth/static-1.1224",
  "quartz-head": "/quartz-head/static-1.1214",
  "quartz-i18n": "/quartz-i18n/static-1.1224",
  "quartz-routing": "/quartz-routing/static-1.979",
  "quartz-test": "/quartz-test/static-1.1224",
  "quartz-tracking": "/quartz-tracking/static-1.928",
  "trellis-components": "/trellis-components/static-1.2865",
  "ui-fonts": "/ui-fonts/static-1.1132",
  "usage-tracker-container": "/usage-tracker-container/static-1.7684",
  "usage-tracker-core": "/usage-tracker-core/static-1.7544",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.271",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "reference-resolvers": "/reference-resolvers/static-1.8564",
  "sanitize-text": "/sanitize-text/static-1.8538",
  "PatternValidationJS": "/PatternValidationJS/static-1.3271",
  "ReduxMessenger": "/ReduxMessenger/static-2.10753",
  "outpost": "/outpost/static-1.4520",
  "rpc-client-utils": "/rpc-client-utils/static-1.5047",
  "sanitize": "/sanitize/static-1.4853",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4875",
  "floating-ui": "/floating-ui/static-1.66",
  "hs-story-utils": "/hs-story-utils/static-1.9805",
  "react-aria": "/react-aria/static-1.75",
  "react-create-root-preference": "/react-create-root-preference/static-1.86",
  "tanstack-table": "/tanstack-table/static-1.64",
  "trellis-assets": "/trellis-assets/static-1.2846",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3342",
  "foundations-theming-base": "/foundations-theming-base/static-1.3844",
  "stylex": "/stylex/static-1.45",
  "hs-locale-management": "/hs-locale-management/static-1.345",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.18",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9863",
  "atom": "/atom/static-1.5462",
  "codemirror": "/codemirror/static-5.105",
  "content-assistance-lib": "/content-assistance-lib/static-1.8296",
  "ContentUtils": "/ContentUtils/static-1.69279",
  "data-token-picker": "/data-token-picker/static-1.16991",
  "file-manager-components": "/file-manager-components/static-1.24655",
  "FileManagerCore": "/FileManagerCore/static-1.40154",
  "FileManagerLib": "/FileManagerLib/static-1.40295",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8302",
  "hub-http-contrib": "/hub-http-contrib/static-1.3408",
  "interframe": "/interframe/static-3.5124",
  "layout-dnd-components": "/layout-dnd-components/static-1.13077",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12052",
  "property-translator": "/property-translator/static-1.5762",
  "react-codemirror": "/react-codemirror/static-1.11023",
  "react-colorpicker": "/react-colorpicker/static-2.10595",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8484",
  "rich-text-lib": "/rich-text-lib/static-1.20417",
  "tinymce-data": "/tinymce-data/static-1.41324",
  "tinymce-themes": "/tinymce-themes/static-1.57209",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10252",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5584",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16716",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.86",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10743",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10741",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5380",
  "base-ui": "/base-ui/static-1.25",
  "react-day-picker": "/react-day-picker/static-1.13",
  "trellis-theming": "/trellis-theming/static-1.1358",
  "tanstack-virtual": "/tanstack-virtual/static-1.41",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.457",
  "chirp-fetch": "/chirp-fetch/static-1.2280",
  "stylex-utils": "/stylex-utils/static-1.155",
  "chatspot-core": "/chatspot-core/static-1.23343",
  "copilot-toolkit": "/copilot-toolkit/static-1.11977",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13412",
  "data-fetching-client": "/data-fetching-client/static-1.10029",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5141",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29441",
  "usage-tracker": "/usage-tracker/static-1.7694",
  "cms-field-types": "/cms-field-types/static-1.5193",
  "content-icons-ui": "/content-icons-ui/static-1.2412",
  "integrations-lib": "/integrations-lib/static-1.17219",
  "customer-data-objects": "/customer-data-objects/static-1.8072",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1927",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5013",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.97",
  "graphql": "/graphql/static-1.92",
  "immer": "/immer/static-1.104",
  "immerable": "/immerable/static-1.4526",
  "poll-commands": "/poll-commands/static-1.3853",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9460",
  "video-components-external": "/video-components-external/static-1.12275",
  "video-data-lib": "/video-data-lib/static-1.35933",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.580",
  "audio-components": "/audio-components/static-1.6445",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29916",
  "FileManagerImages": "/FileManagerImages/static-1.37806",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1631",
  "html-to-image": "/html-to-image/static-1.64",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "salesImages": "/salesImages/static-1.643",
  "ui-universal-auth": "/ui-universal-auth/static-1.9548",
  "urlinator": "/urlinator/static-1.4899",
  "video-components": "/video-components/static-1.14277",
  "video-embed": "/video-embed/static-1.36767",
  "ts-schema": "/ts-schema/static-1.4343",
  "ContentData": "/ContentData/static-1.69354",
  "layout-data-lib": "/layout-data-lib/static-1.10377",
  "react-dnd-compat": "/react-dnd-compat/static-1.4996",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1927",
  "external-options-client-types": "/external-options-client-types/static-1.4390",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7277",
  "hs-promise-utils": "/hs-promise-utils/static-1.5970",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4092",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9308",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3446",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11531",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5819",
  "magpie-types": "/magpie-types/static-1.5279",
  "simple-logging-lib": "/simple-logging-lib/static-1.3434",
  "avatar-components": "/avatar-components/static-1.2864",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10213",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6966",
  "flux-actions": "/flux-actions/static-1.377",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5256",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14634",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5993",
  "laboratory-lib": "/laboratory-lib/static-3.7534",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8147",
  "redux-observable": "/redux-observable/static-1.78",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10653",
  "unified-auth": "/unified-auth/static-1.1062",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.905",
  "breeze-engine-core": "/breeze-engine-core/static-1.1205",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "pulse": "/pulse/static-1.1013",
  "navigation-messaging": "/navigation-messaging/static-1.8292",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13401",
  "content-media-compositions": "/content-media-compositions/static-2.17408",
  "idb-keyval": "/idb-keyval/static-1.54",
  "media-bridge-lib": "/media-bridge-lib/static-1.19507",
  "nudge-client-utils": "/nudge-client-utils/static-1.3256",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1344",
  "social-insights-client-types": "/social-insights-client-types/static-1.22768",
  "advanced-menus-core": "/advanced-menus-core/static-1.15675",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12508",
  "ExportDialog": "/ExportDialog/static-6.10759",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34974",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4065",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4396",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.396",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4270",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7182",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3721",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3959",
  "persist-promise": "/persist-promise/static-1.4084",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6089",
  "reactive-lib": "/reactive-lib/static-1.1103",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.715",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3392",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.604",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1631",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.112",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1167",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.315",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.660",
  "slack-ui-library": "/slack-ui-library/static-1.10779",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.516",
  "event-emitter": "/event-emitter/static-1.1340",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3013",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3332",
  "onboarding-tours": "/onboarding-tours/static-1.17247",
  "whisper-core-api": "/whisper-core-api/static-1.7469",
  "fsm": "/fsm/static-1.4135",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15674",
  "simple-menus-lib": "/simple-menus-lib/static-1.17191",
  "settings-ui-lib": "/settings-ui-lib/static-1.12906",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3818",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10246",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19387",
  "growth-data-modal": "/growth-data-modal/static-1.5997",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2824",
  "navigation-components": "/navigation-components/static-1.18965",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5462",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1314",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8034",
  "user-context": "/user-context/static-1.5473",
  "react-flip-move": "/react-flip-move/static-1.81",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2662",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2852",
  "user-context-client": "/user-context-client/static-1.4890",
  "nest": "/nest/static-1.616",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18505",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15686",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7993",
  "onboarding-scopes": "/onboarding-scopes/static-1.6834"
}
};
